import React from 'react';
import PropTypes from 'prop-types';
import {withContext, getContext} from 'recompose';

export class PermissionRepository {
    constructor(permissions) {
        this.permissions = permissions;

        this.isGranted = this.isGranted.bind(this);
    }

    isGranted(permission) {
        if (!permission in this.permissions) {
            throw new Error(`Permission "${permission}" is not defined.`);
        }

        return !!this.permissions[permission];
    }
}

export const PermissionProvider = withContext(
    {
        isGranted: PropTypes.func.isRequired,
    },
    ({isGranted}) => ({isGranted})
)(
    ({children}) => React.Children.only(children)
);

export const withPermissions = getContext({
    isGranted: PropTypes.func.isRequired,
});

export const WhenGranted = withPermissions(
    ({isGranted, permission, children}) => (
        isGranted(permission)
            ? React.Children.only(children)
            : null
    )
);
